import {UserSummaryConverter} from '../../account/modules/user/api/converter/userSummary.converter';
import {EntityWithAuditMetadata} from '../entity/entityWithAuditMetadata';
import {EntityWithCreatedAtMetadataConverter} from './entityWithCreatedAtMetadata.converter';
import {Injectable} from '@angular/core';
import {DateConverter} from './date.converter';

@Injectable({
    providedIn: 'root'
})
export class EntityWithAuditMetadataConverter {

    constructor(private userSummaryConverter: UserSummaryConverter,
                private dateConverter: DateConverter,
                private entityWithCreatedAtMetadataConverter: EntityWithCreatedAtMetadataConverter) {
    }

    public convert <T extends EntityWithAuditMetadata>(target: T, entity: T): T {
        target.updatedAt = this.dateConverter.convert(entity.updatedAt);
        target.updatedBy = this.userSummaryConverter.convert(entity.updatedBy);
        return this.entityWithCreatedAtMetadataConverter.convert(target, entity);
    }
}
